
export default {
    state:{
       organize:[],
       communities:[]
    },
    getters:{
       
    },
    mutations:{
       updateOrga(state,param){
          state.organize = param;
       },
       updateCom(state,param){
         state.communities = param;
      }
    },
    actions:{

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/organize.js